var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-card',[_c('w-card-title',[_vm._v(_vm._s(_vm.$ct('titles.product-groups')))]),_c('w-card-content',[_c('app-product-group-select-autcomplete',{attrs:{"value":_vm.value,"use-id":""},on:{"input":function($event){return _vm.onInput($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }